/**
 * Caps how many wrapped async tasks run at once; the rest queue and start as slots free up.
 * Used to throttle per-widget data fetches so a dashboard with many graph widgets does not
 * fire every request (and its backend KPI resolution) at the same time.
 */
export function createConcurrencyLimiter(maxConcurrent: number) {
    let active = 0;
    const queue: Array<() => void> = [];

    const release = () => {
        active -= 1;
        queue.shift()?.();
    };

    return function run<T>(task: () => Promise<T>): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            const start = () => {
                active += 1;
                task().then(resolve, reject).finally(release);
            };
            if (active < maxConcurrent) {
                start();
            } else {
                queue.push(start);
            }
        });
    };
}
